export default __webpack_public_path__ + "static/media/OldPortfolio-min.2fe90ff6.PNG";